// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__3BCDd","noInteraction":"EventWrapper_noInteraction__3OBVj","pointerPassthrough":"EventWrapper_pointerPassthrough__3GppX"};